import { useContext } from "react";
import PropTypes from 'prop-types';

import NotificationContext from "../../context/NotificationContext";

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import SearchBar from './SearchBar';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Tooltip from "@mui/material/Tooltip";

const ListHeader = ({ title, handleClick, hasCreatePermission, search, pageData }) => {
  const { notificationCount, handleNotificationClick } = useContext(NotificationContext);

  return(
    <Grid container spacing={1} style={{ marginTop: 2 }}>
      <Grid 
        item 
        xs={12} 
        sm={hasCreatePermission ? 3.5 : 5.25} 
        md={hasCreatePermission ? 4.75 : 6} 
        lg={hasCreatePermission ? 5 : 6.25} 
        xl={hasCreatePermission ? 6.25 : 7}
      >
        <Typography 
          component="h4" 
          variant="h4" 
          color={'text.secondary'} 
        >
          <strong>{title}</strong>
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5} md={5} lg={5} xl={4.5}>
        <SearchBar search={search} pageData={pageData} />
      </Grid>

      {hasCreatePermission &&
        <Grid item xs={6} sm={2} md={1.5} lg={1.25} xl={0.75}>
          <Button
            variant="contained" 
            color="success"
            onClick={handleClick}
          >
            Create
          </Button>
        </Grid>
      }

      <Grid item xs={6} sm={1.5} md={0.75} lg={0.75} xl={0.5}>
        <Box 
          justifyContent="center"
          alignItems="center"
          sx={{
            marginTop: -1,
          }}
        >
          <Tooltip title="View notifications" arrow>
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handleNotificationClick}
            >
              <Badge badgeContent={notificationCount} color="error">
                <NotificationsIcon 
                  color="action" 
                  style={{
                    width: 30,
                    height: 30,
                  }}
                />
              </Badge>
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
};

ListHeader.propTypes = {
  title: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  hasCreatePermission: PropTypes.bool.isRequired,
  search: PropTypes.func.isRequired,
  pageData: PropTypes.object.isRequired,
};

export default ListHeader;